import { render, staticRenderFns } from "./loginpIdt.vue?vue&type=template&id=048a8a7d"
import script from "./loginpIdt.vue?vue&type=script&lang=js"
export * from "./loginpIdt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports